// =====================================================
// 📁 components/QuotationViewActions.tsx
// =====================================================

import React from 'react';
import useQuotationPdf from '../../../../../../hooks/pdf/useQuotationPdf';


interface Props {
  quotation: any;
  onClose: () => void;
}

const QuotationViewActions: React.FC<Props> = ({ quotation, onClose }) => {
  // =====================================================
  // 🔹 Hooks
  // =====================================================

  const { handleDownloadQuotationPdf } = useQuotationPdf();

  return (
    <div
      className="
        flex items-center justify-end
        gap-3 border-t border-stroke
        pt-5 dark:border-strokedark
      "
    >
      {/* PDF */}
      <button
        onClick={() => {
          handleDownloadQuotationPdf(quotation.id);
        }}
        className="
          rounded-sm bg-primary
          px-5 py-2 font-medium
          text-white transition
          hover:bg-opacity-90
        "
      >
        Descargar PDF
      </button>

      {/* Close */}
      <button
        onClick={onClose}
        className="
          rounded-sm border border-stroke
          px-5 py-2 font-medium
          dark:border-strokedark
        "
      >
        Cerrar
      </button>
    </div>
  );
};

export default QuotationViewActions;
